import { AdvtFullSize } from './AdvtFullSize/AdvtFullSize';
import { BgVideoLines } from './BgVideoLines/BgVideoLines';
import { BgVideoWord } from './BgVideoWord/BgVideoWord';
import { StartBgVideoWord } from './StartBgVideoWord/StartBgVideoWord';
import { WordCloud } from './WordCloud/WordCloud';

import styles from './WordCloudWraper.module.css';

export const WordCloudWraper = ({ options, wordsInTitre }) => {
  return (
    <div className={styles.wrapper}>
      <AdvtFullSize />

      <div className={styles.words}>
        <WordCloud options={options} wordsInTitre={wordsInTitre} />
      </div>

      <StartBgVideoWord delay={9000} />
      <BgVideoLines />
      <BgVideoWord delay={9000} />
    </div>
  );
};
